import { useAuth } from 'hooks';
import { createContext, FunctionComponent, PropsWithChildren, useContext, useMemo, useState } from 'react';

interface MessagesChannelMarketplaceContextValue {
    effectiveMarketplaceId: number | undefined;
    setMessagesMarketplaceOverride: (marketplaceId: number | undefined) => void;
}

const MessagesChannelMarketplaceContext = createContext<MessagesChannelMarketplaceContextValue | null>(null);

export const MessagesChannelMarketplaceProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const auth = useAuth();
    const [overrideId, setOverrideId] = useState<number | undefined>();

    const effectiveMarketplaceId = overrideId ?? auth.marketplaceId;

    const value = useMemo(
        () => ({
            effectiveMarketplaceId,
            setMessagesMarketplaceOverride: setOverrideId
        }),
        [effectiveMarketplaceId]
    );

    return (
        <MessagesChannelMarketplaceContext.Provider value={value}>
            {children}
        </MessagesChannelMarketplaceContext.Provider>
    );
};

export const useMessagesChannelMarketplace = (): MessagesChannelMarketplaceContextValue => {
    const context = useContext(MessagesChannelMarketplaceContext);

    if (!context) {
        throw new Error('useMessagesChannelMarketplace must be used within MessagesChannelMarketplaceProvider');
    }

    return context;
};

export default MessagesChannelMarketplaceProvider;
